<template>
  <div>
    <div @click="openKeFu" class="keuf"><i class="el-icon-service"></i>
      <!-- <div><img :src="require('.././assets/img/erweima.png')"/></div> -->
    </div>
    <div @click="openWenDang" class="wendang"><i class="el-icon-document"></i>帮<br />助<br />引<br />导<br /></div>
  </div>
</template>
<script>
export default {
  props: {
    helpUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    openWenDang(){
      // 使用从父组件传递进来的链接
      window.open(this.helpUrl, '_blank');
    },
    openKeFu(){
      window.open('https://work.weixin.qq.com/kfid/kfc7ec6ced59b790e87', '微信客服', 'width=600,height=500');
    }
  }
}
</script>
<style scoped>
.wendang{
  width: 40px;
  height: 100px;
  background: white;
  border: 1px solid #ecedef;
  box-shadow: 0px 0px 10px #dadada;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  position: fixed;
  bottom: 70px;
  right: 10px;
  cursor: pointer;
  font-size: 14px;
  text-align: center;
  padding: 10px 0;
  z-index: 9999;
}
.wendang i{
  font-size: 20px;
  padding: 0 10px;
}

.keuf{
  width: 40px;
  height: 40px;
  background: white;
  border: 1px solid #ecedef;
  box-shadow: 0px 0px 10px #dadada;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 200px;
  right: 10px;
  cursor: pointer;
  z-index: 9999;
}
.keuf i{
  font-size: 20px;
}
.keuf:hover div{
  display: flex;
}
.keuf div{
  display: none;
  width: 200px;
  height: 200px;
  position: absolute;
  left: -220px;
  top: 50%;
  transform: translateY(-50%);
  background: white;
  border: 1px solid #ecedef;
  box-shadow: 0px 0px 10px #dadada;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
}
.keuf div img{
  width: 180px;
  height: 180px;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/helpOther.vue